import React from 'react';
import { Container, Typography, Box, Paper, ThemeProvider, Divider } from '@mui/material';
import NavBar from '../../layout/NavBar';
import NavBarBot from '../../layout/NavBarBot';
import { darkTheme } from '../../../theme/darkTheme';

const Impressum = () => {
    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: 8 }}>
                <NavBar />
                <Container maxWidth="md" sx={{ mt: 4 }}>
                    <Paper 
                        elevation={3} 
                        sx={{ 
                            p: { xs: 3, md: 5 }, 
                            borderRadius: '16px', 
                            bgcolor: 'background.paper',
                            border: '1px solid rgba(59, 130, 246, 0.2)' 
                        }}
                    >
                        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'primary.main', mb: 4 }}>
                            Impressum
                        </Typography>

                        <Typography variant="h6" gutterBottom sx={{ color: '#e0f2fe', fontWeight: 600 }}>
                            Angaben gemäß § 5 TMG
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
                            Philipp Feld<br />
                            Mainstraße 7<br />
                            49809 Lingen
                        </Typography>

                        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />

                        <Typography variant="h6" gutterBottom sx={{ color: '#e0f2fe', fontWeight: 600 }}>
                            Kontakt
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
                            Telefon: 01713482859<br />
                            E-Mail: philipp.feld@web.de
                        </Typography>

                        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />

                        <Typography variant="h6" gutterBottom sx={{ color: '#e0f2fe', fontWeight: 600 }}>
                            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
                            Philipp Feld<br />
                            Mainstraße 7<br />
                            49809 Lingen
                        </Typography>

                        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />

                        <Typography variant="h6" gutterBottom sx={{ color: '#e0f2fe', fontWeight: 600 }}>
                            Streitschlichtung
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', marginLeft: '5px' }}>
                                https://ec.europa.eu/consumers/odr
                            </a>.<br />
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.<br /><br />
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </Typography>
                    </Paper>
                </Container>
            </Box>
            <NavBarBot />
        </ThemeProvider>
    );
};

export default Impressum;
